import { Component, OnInit, Input } from '@angular/core';
import { MatTableDataSource, MatDialogConfig, MatDialog } from '@angular/material';
import { Matter } from '../../requets/shared/matter.model';
import { SelectSubjectRequestDialogComponent } from '../../../core/modal/select-subject-request-dialog/select-subject-request-dialog.component';

@Component({
  selector: 'app-subjects-criteria',
  templateUrl: './subjects-criteria.component.html',
  styleUrls: ['./subjects-criteria.component.scss']
})
export class SubjectsCriteriaComponent implements OnInit {
  @Input() program;
  @Input() version;
  subjects: Matter[] = [];
  messageError = '';
  displayedColumns: string[] = ['codigo', 'materia', 'action'];
  dataSource: MatTableDataSource<Matter>;

  constructor(private dialog: MatDialog) { }

  ngOnInit() {
  }

  deleteSubject(item) {
    this.subjects.splice(item, 1);
    this.dataSource = new MatTableDataSource(this.subjects);
  }

  searchSubject() {
    const dialogConfig = new MatDialogConfig();
    dialogConfig.width = '70%';
    dialogConfig.data = {
      program: this.program,
      version: this.version,
      cualitative: true,
    };
    const dialogRef = this.dialog.open(SelectSubjectRequestDialogComponent, dialogConfig);
    dialogRef.afterClosed().subscribe(
      (result) => {
        if (result !== null) {
          this.messageError = '';
          const subject = result.item as Matter;
          if (this.subjects.findIndex((sub) => sub.codigo === subject.codigo) < 0) {
            this.subjects.push(subject);
            this.dataSource = new MatTableDataSource(this.subjects);
          } else {
            this.messageError = 'La materia ' + subject.nombre + ' ya fue añadida';
          }

        }
      }
    );

  }

}
